import { render, staticRenderFns } from "./LayoutTable.vue?vue&type=template&id=1e2b74fc&scoped=true"
import script from "./LayoutTable.vue?vue&type=script&lang=js"
export * from "./LayoutTable.vue?vue&type=script&lang=js"
import style0 from "./LayoutTable.vue?vue&type=style&index=0&id=1e2b74fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b74fc",
  null
  
)

export default component.exports